import React from 'react';
import { FaMoneyBillWave } from 'react-icons/fa';
import { useAuth } from '../../AuthContext';
import { hasPermission, isAdmin } from '../../utils/permissions';
import YoungApprenticeCompensationCatalogs from './YoungApprenticeCompensationCatalogs';
import './YoungApprentice.css';
import './YoungApprenticeEnhancements.css';
import './YoungApprenticeOperational.css';

const MANAGE_PERMISSION = 'GERENCIAR_CADASTROS_JOVEM_APRENDIZ';

export default function YoungApprenticeCompensationPage() {
  const { user } = useAuth();
  const canManage = Boolean(user?.isMaster) || isAdmin(user) || hasPermission(user, MANAGE_PERMISSION);
  return <div className="young-apprentice-page ya-font-montserrat ya-clean-page">
    <header className="ya-clean-header ya-clean-header--navy"><div><span className="ya-page-toolbar__icon"><FaMoneyBillWave /></span><div><h1>Cadastros</h1></div></div></header>
    <section className="young-apprentice-card ya-compensation-page-card"><YoungApprenticeCompensationCatalogs canManage={canManage} /></section>
  </div>;
}
